<router-outlet></router-outlet>




// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/app.component.html